// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "强化学习",
      "tec": "韩吉",
      "week": "1-6周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "图像处理与机器视觉",
      "tec": "唐冲",
      "week": "1-8周",
      "add": "实训楼F座203自控"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "多智能体系统",
      "tec": "韩吉",
      "week": "6-11周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "机器人控制技术",
      "tec": "王森",
      "week": "2-11周",
      "add": "实训楼F座517自控"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "强化学习",
      "tec": "韩吉",
      "week": "1-6周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "JAVA程序设计",
      "tec": "衣云龙",
      "week": "1-8周",
      "add": "实训楼F座104信机"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "多智能体系统",
      "tec": "韩吉",
      "week": "6-11周",
      "add": "实训楼F座202自控"
    },
    {
      "sub": "图像处理与机器视觉",
      "tec": "唐冲",
      "week": "1-8周",
      "add": "实训楼F座202自控"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "JAVA程序设计",
      "tec": "衣云龙",
      "week": "1-8周",
      "add": "实训楼F座104信机"
    },
    0,
    {
      "sub": "机器人控制技术",
      "tec": "王森",
      "week": "2-11周",
      "add": "实训楼F座517自控"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
